import { createContext, useContext } from "react";

export const AdminLayoutContext = createContext(null);

export const useAdminLayoutContext = () => useContext(AdminLayoutContext);
